<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-alert
            v-if="error_alert"
            text
            prominent
            type="error"
            icon="mdi-cloud-alert"
        >{{ error_alert }}</v-alert
        >
        <v-alert
            v-if="success_alert"
            text
            prominent
            type="success"
            icon="mdi-cloud-alert"
        >{{ success_alert }}</v-alert
        >
      </v-col>

      <v-row>
        <v-col cols="12">
          <v-card-title>
            Counselor Incentive Setup
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>

            <v-col cols="12" sm="6" md="4">
              <template>
                <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-btn depressed color="primary" @click="dialog = true">
                Add New Range
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-btn
                  depressed
                  color="primary"
                  append-icon="mdi-printer"
                  v-on:click="printList"
              >Print
              </v-btn>
            </v-col>
          </v-card-title>
          <div id="print">
            <v-card>
              <v-data-table
                  :headers="headers"
                  :items="desserts"
                  class="elevation-1"
                  :search="search"
                  dense
                  mobile-breakpoint="0"
                  disable-pagination
                  :hide-default-footer="true"
                  :loading="loadingstatus"
                  loading-text="Loading... Please wait"
              >
                <template v-slot:item.action="{ item }">
                  <v-tooltip top >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                          @click="get_update(item)"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          class="ma-2"
                          color="orange"
                          label
                          outlined
                          small
                      ><v-icon> mdi-pencil </v-icon>
                      </v-chip>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-row>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Counselor Incentive
              <span v-if="formData.operation_name">Operation: {{ formData.operation_name }}</span>
            </v-card-title>

            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12" v-if="!formData.operation_name">
                      <v-autocomplete
                          v-model="formData.operation_id"
                          :items="operation_list"
                          item-text="name"
                          item-key="id"
                          outlined
                          dense
                          label="Operation"
                          return-object
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="formData.start_range"
                          :counter="10"
                          outlined
                          dense
                          label="Start Range"
                          required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="formData.end_range"
                          :counter="10"
                          outlined
                          label="End Range"
                          required
                          dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="formData.incentive_amount"
                          :counter="10"
                          outlined
                          label="Incentive Amount"
                          required
                          dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                          v-model="formData.status"
                          :items="status"
                          label="Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text  @click="formDataRefresh()"> Cancel </v-btn>
              <v-btn color="primary" text @click="formSubmit()"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      search: "",
      dialog: false,
      error_alert: null,
      success_alert: null,
      loadingstatus: true,
      operation_list: [],
      status: ["Active", "Inactive"],
      headers: [
        {text: "ID", align: "start", sortable: false, value: "id",},
        { text: "Operation Name", value: "operation.name" },
        { text: "Start Range", value: "start_range" },
        { text: "End Range", value: "end_range" },
        { text: "Incentive Amount", value: "incentive_amount" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      formData: {
        id: null,
        operation_name: null,
        operation_id: null,
        start_range: 0,
        end_range: 0,
        incentive_amount: 0,
        status: null,
      },

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Operations Bill",
          disabled: true,
          href: "patients",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    let logged_user = localStorage.getItem("userId");
    let permitted = ["1", "50", "61","64"];
    if (permitted.includes(logged_user)) {
      console.log(permitted);
    } else {
      this.loadingstatus = false;
      this.error_alert = "Invalid Request ";
      return false;
    }
    this.get_operation_list();
    this.initialize();
  },
  methods: {
    initialize() {
      atshq
          .get("ot-module/ot-setup-counselor-incentive")
          .then((response) => {
            this.desserts = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    get_operation_list() {
      atshq
          .get("operations")
          .then((response) => {
            this.operation_list = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },

    formSubmit() {
      if (confirm("are you sure?"))
        if (this.formData.id) {
          atshq
              .put("ot-module/ot-setup-counselor-incentive/" + this.formData.id, {
                formdata: this.formData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.messages);
                this.initialize();
                this.formDataRefresh();
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
              })
        } else {
          atshq
              .post("ot-module/ot-setup-counselor-incentive", {
                formdata: this.formData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$noty.success(res.data.messages);
                  this.success_alert = res.data.messages;
                  this.initialize();
                  this.formDataRefresh();
                }
              })
              .catch((e) => {
                this.$noty.error("Oops, something went wrong!");

                this.errors.push(e);
              })
        }
    },

    get_update(items) {
      this.dialog = true;
      this.formData.id = items.id;
      this.formData.operation_name = items.operation.name;
      this.formData.operation_id = items.operation_id;
      this.formData.start_range = items.start_range;
      this.formData.end_range = items.end_range;
      this.formData.incentive_amount = items.incentive_amount;
      this.formData.status = items.status;
    },
    formDataRefresh() {
      this.dialog = false;
      this.formData.id = null;
      this.formData.operation_name = null;
      this.formData.operation_id = null;
      this.formData.start_range = null;
      this.formData.end_range = null;
      this.formData.incentive_amount = null;
      this.formData.status = null;
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write(
          '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
      );
      docprint.document.write(
          '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      );
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );

      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
          "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>